import React from 'react';
import InitPagination from './InitPagination';
export default (props) => {
  return <InitPagination {...props}></InitPagination>;
};
